import { Routes } from '@angular/router';
import { Page403Component } from '@shared-angular/components/page-403/page-403.component';
import { botAdminRoute } from './bot-admin.routes';
import { ImportComponent } from './routes/ai-bot/import/import.component';
import { MdPreviewComponent } from './routes/ai-bot/md-preview/md-preview.component';
import { MiroComponent } from './routes/auth/miro/miro.component';
import { ReflactTrainComponent } from './routes/auth/reflact-train/reflact-train.component';
import { DebugSplitViewComponent } from './routes/debug-view/debug-split-view.component';
import { DebugViewComponent } from './routes/debug-view/debug-view.component';
import { LoginComponent } from './routes/login/login.component';
import { authGuard } from './shared/guards/auth.guard';
import { portalLoginResolver } from './shared/resolver/PortalLogin.resolver';


export const routes: Routes = [
  {
    path: 'logtologin',
    loadComponent: () => import('@shared-angular/components/logto-login/logto-login.component').then(module => module.LogtoLoginComponent),
    data: { logtoTarget: 'admin' }
  },
  {
    path: 'logto/callback',
    loadComponent: () => import('@shared-angular/components/logto-login/logto-login.component').then(module => module.LogtoLoginComponent),
    data: { logtoTarget: 'admin', logtoCallback: true }
  },
  {
    path: "",
    pathMatch: "full",
    redirectTo: "bot-admin"
  },
  {
    path: "portallogin/:deeplink",
    pathMatch: "full",
    component: LoginComponent,
    resolve: {
      portalLogin: portalLoginResolver
    }
  },
  {
    path: "portallogin",
    pathMatch: "full",
    component: LoginComponent,
    resolve: {
      portalLogin: portalLoginResolver
    }
  }, {
    path: 'auth/miro',
    pathMatch: 'full',
    component: MiroComponent
  },
  {
    path: 'auth/reflact-train',
    pathMatch: 'full',
    component: ReflactTrainComponent
  },
  //! HIER SIND DIE ADMIN ROUTES
  botAdminRoute,
  {
    path: "bot-import/:token",
    pathMatch: "full",
    component: ImportComponent,
    data: { isFullScreenLayout: true },
    canActivate: [
      authGuard
    ]
  },
  {
    path: "mdpreview/:docid",
    pathMatch: "full",
    component: MdPreviewComponent,
    data: { isFullScreenLayout: true },
    canActivate: [
      authGuard
    ]
  },
  {
    path: "mdpreview/:botid/:toolid",
    pathMatch: "full",
    component: MdPreviewComponent,
    data: { isFullScreenLayout: true },
    canActivate: [
      authGuard
    ]
  },
  {
    path: 'debug/:id',
    pathMatch: 'full',
    component: DebugViewComponent,
    data: { isFullScreenLayout: true },
    canActivate: [authGuard]
  },
  {
    path: 'debug-split/:id',
    pathMatch: 'full',
    component: DebugSplitViewComponent,
    data: { isFullScreenLayout: true },
    canActivate: [authGuard]
  },
  {
    path: '403',
    pathMatch: 'full',
    component: Page403Component
  },
  {
    path: '**',
    redirectTo: 'bot-admin'
  }
];


